/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Autocomplete wrapper stuff

namespace('Slzr', function(exports, top) {
  const $ = Slzr.jQuery;

  // This encapsulates our extensions to jQuery UI's autocomplete
  return (function() {
    const Cls = (exports.Autocomplete = class Autocomplete {
      static initClass() {
  
        this.prototype.defaults = {
          formatter: null,
          loadingMessage: "Loading...",
          typeMessage: null,
          partialChars: 2,
          // If set, will allow the literal text to be used.  @TEXT@ will be
          // replaced with the entered text
          useAsEnteredMessage: null,
          delay: 100,
          minLength: 2,
          // Function that filters items (results, term)
          itemFilter: null
        };
      }
      // Escape a string's special regular expression characters (parens,
      // brackets, pipe, backslash)
      static escapeRegexp(str) {
        return str.replace(/(\(|\)|\||\\|\[|\])/g, '\\$1').replace(/(\.)/, '\\$1');
      }

      constructor(el, options) {
        this.options = $.extend({}, this.defaults, options);
        if (!this.options.formatter) { this.options.formatter = this.basicFormatter; }
        if (!this.options.itemFilter) { this.options.itemFilter = this.filterResults; }
        this.cache = {};
        this.requests_in_progress = {};

        el = $(el);

        if (!el[0]) { return; }

        this.element = el;

        options = $.extend({}, this.options,
          {source: (request, response) => this.getResults(request, response)});

        this.autocomplete = $(el).autocomplete(options).data('ui-autocomplete');
        this.autocomplete._renderItem = (ul, item) => this.renderItem(ul, item);

        // Select the first item automatically
        $(el).on('autocompleteopen.slzrAutocomplete', () => {
          const {
            menu
          } = this.autocomplete;
          // Findt he target (if use is enabled, use #2 unless only one)
          const children = menu.element.children();
          let selection = children.first();
          if (this.options.useAsEnteredMessage && (children.length > 1)) {
            selection = children.eq(1);
          }

          return menu.next();
        });
          // menu.focus $.Event({type: 'mouseenter'}), selection

        // Loading indicator
        if (this.options.loadingMessage) {
          $(el).on('autocompletesearch.loadingMessage', ev => {});
            // @startIndicator()

          $(el).on('autocompleteopen.loadingMessage blur.loadingMessage autocompleteclose.loadingMessage', ev => {
            return _.defer(() => this.stopIndicator());
          });
        }
      
        if (this.options.typeMessage) {
          $(el).on('focus.typeMessage', ev => {
            return this.showMessage(this.options.typeMessage);
          });

          $(el).on('blur.typeMessage autocompleteclose.typeMessage', ev => {
            return _.defer(() => this.stopIndicator());
          });
        }
      }

      // Prepare the message div
      prepareMessageDiv() {
        if (!this.message_div) { this.message_div = $('<ul></ul>')
          .addClass('ui-autocomplete')
          .appendTo( $(this.autocomplete.options.appendTo || 'body')[0] )
          .css('zIndex', (parseInt(this.autocomplete.element.css('zIndex'), 10) || 0) + 1); }
        return this.message_div.empty();
      }

      // Show the message div
      showMessageDiv() {
        this.autocomplete.close();
        this.message_div.show();
        this.message_div.outerWidth(Math.max(
          this.message_div.width('').outerWidth(),
          this.autocomplete.element.outerWidth()
        )
        );
        return this.message_div.position($.extend({of: this.autocomplete.element}, this.autocomplete.options.position));
      }

      // Show the tip message
      showMessage(msg) {
        this.prepareMessageDiv();
        this.renderItem(this.message_div, {label: msg});
        return this.showMessageDiv();
      }

      // Show the loading dropdown
      startIndicator() {
        return this.showMessage(this.options.loadingMessage);
      }

      // Hide the loading dropdown
      stopIndicator() {
        if (this.message_div) { return this.message_div.hide(); }
      }

      renderItem(ul, item) {
        return $('<li></li>')
          .data('ui-autocomplete-item', item)
          .append( $('<a></a>').html(item.label) )
          .appendTo(ul);
      }

      getResults(request, response) {
        const term = this.cleanStringPrefix(request.term);
        const self = this;
        return this.requestResults(term, function(results) {
          // Format the results to how the widget expects it
          const filtered_results = self.options.itemFilter(results, term);
          results = $.map(filtered_results, function(e) {
            let value;
            let label = self.options.formatter(e, term, self);
            if (_.isString(label)) {
              value = $('<div/>').html(label).text();
            } else {
              ({
                value
              } = label);
              ({
                label
              } = label);
            }

            // Return a valid result for this element
            return {
              data: e,
              label,
              id: e.id,
              value
            };
        });

          if (self.options.useAsEnteredMessage) {
            // Use request.term, to keep any "a/an/the" prefix the user
            // entered
            const text_label = self.options.useAsEnteredMessage.replace('@TEXT@', request.term);
            results.unshift({
              data: {raw: true, text: request.term},
              label: text_label,
              value: request.term,
              id: `text_${term}`
            });
          }

          self.stopIndicator();
          return response(results);
        });
      }

      // Only return results matching term
      filterResults(results, term) {
        const lower_term = term.toLowerCase();
        const escaped_entry = Slzr.Autocomplete.escapeRegexp(lower_term);
        const check_re = new RegExp(`\\b${escaped_entry}`, 'i');
        return _.select(results, i => check_re.test(i.name));
      }

      requestResults(term, callback) {
        if (term.length >= this.options.partialChars) {
          const prefix = term.substr(0, this.options.partialChars).toLowerCase();
          const the_url = _.isFunction(this.options.url) ?
            this.options.url()
          :
            this.options.url;

          let key = `${the_url}|${prefix}`;

          if (typeof this.options.extraCacheKey === 'function') {
            key += `|${this.options.extraCacheKey()}`;
          }

          const self = this;

          if (self.cache[key]) {
            return callback(self.cache[key]);
          } 
            if (!self.requests_in_progress[key]) {
              self.requests_in_progress[key] = true;
              const ajax_options = typeof self.options.extraParams === 'function' ?
                self.options.extraParams()
              : self.options.extraParams ?
                self.options.extraParams
              :
                {};

              ajax_options.value = prefix;

              return $.ajax({
                url: the_url,
                data: ajax_options,
                dataType: 'json',
                success(data) {
                  self.cache[key] = data;
                  self.requests_in_progress[key] = false;
                  return callback(self.cache[key]);
                },
                error() {
                  return callback([]);
                }});
            }
          
        } else {
          return callback([]);
        }
      }


      // Strip the, an, a from the beginning of str
      cleanStringPrefix(str) {
        return str.replace(/^(the|a|an)\s+/i, '')
          .replace(/^\s+|\s+$/g, '');
      }

      // Return the label for this object
      //
      basicFormatter(obj, term, autocomplete) {
        const ret = '';
        const entry = term;
        const escaped_entry = Slzr.Autocomplete.escapeRegexp(entry);
        const replacement = new RegExp(`(${escaped_entry})`, "ig");
        return obj.name.replace(replacement, '<strong class="highlight">$1</strong>');
      }

      destroy() {
        this.autocomplete.destroy();
        if (this.message_div != null) {
          this.message_div.remove();
        }
        this.element.off('.slzrAutocomplete');
        this.element.off('.typeMessage');
        return this.element.off('.loadingMessage');
      }
    });
    Cls.initClass();
    return Cls;
  }());
});

// Autocomplete formatters
namespace('Slzr.Formatter', function(exports, top) {
  exports.nameWithAddress = function(obj, term, autocomplete) {
    let ret = '';
    const entry = term;
    const escaped_entry = Slzr.Autocomplete.escapeRegexp(entry);
    const replacement = new RegExp(`(${escaped_entry})`, "ig");
    const highlighted_name = obj.name.replace(replacement, '<strong class="highlight">$1</strong>');

    ret = highlighted_name;
    if (obj.address) {
      ret += '<div class="informal location">';
      ret += obj.address;
      ret += '</div>';
    }

    return {value: obj.name, label: ret};
  };

  exports.nameWithBusinessType = function(obj, term, autocomplete) {
    let ret = '';
    const entry = term;
    const escaped_entry = Slzr.Autocomplete.escapeRegexp(entry);
    const replacement = new RegExp(`(${escaped_entry})`, "ig");
    const highlighted_name = obj.name.replace(replacement, '<strong class="highlight">$1</strong>');

    ret = highlighted_name;
    if (obj.business_type) {
      ret += '<div class="informal location">';
      ret += obj.business_type;
      ret += '</div>';
    }

    return {value: obj.name, label: ret};
  };

  exports.nameWithPlaceType = exports.nameWithBusinessType;

  exports.nameWithDateAndDescription = function(obj, term, autocomplete) {
    let ret = '';
    const entry = term;
    const escaped_entry = Slzr.Autocomplete.escapeRegexp(entry);
    const replacement = new RegExp(`(${escaped_entry})`, "ig");
    const highlighted_name = obj.name.replace(replacement, '<strong class="highlight">$1</strong>');

    ret += '<span class="dateright">';
    ret += Date.parse(obj.starts_at).toString('M/d');
    ret += '</span>';

    ret += highlighted_name;
    if (obj.description) {
      ret += '<div class="informal">';
      ret += substr(obj.description, 0, 160);
      ret += '</div>';
    }

    return {value: obj.name, label: ret};
  };

  return exports.nameWithEmail = function(obj, term, autocomplete) {
    let ret = '';
    const entry = term;
    const escaped_entry = Slzr.Autocomplete.escapeRegexp(entry);
    const replacement = new RegExp(`(${escaped_entry})`, "ig");
    const highlighted_name = obj.name.replace(replacement, '<strong class="highlight">$1</strong>');
    const highlighted_email = obj.email.replace(replacement, '<strong class="highlight">$1</strong>');

    ret = highlighted_name;
    ret += '<div class="informal location">';
    ret += highlighted_email;
    ret += '</div>';

    return {value: obj.email, label: ret};
  };
});

namespace('Slzr', function(exports, top) {
  const $ = Slzr.jQuery;

  exports.initializeAutocompletes = () => $('input[data-autocomplete]').each(function() {
    let data_url;
    const $this = $(this);
    const data = $this.data();

    if (data['slzr.autocomplete'] !== undefined) { return; }

    const autocomplete_type = data.autocomplete;

    switch (autocomplete_type) {
      case 'places':
        data_url = '/settings/get_business_list';
        break;
      case 'event-place':
        data_url = '/event/place_lookup';
        break;
      default:
        return false;
    }

    const formatter = Slzr.Formatter[data.autocompleteFormatter];

    const select_function = Slzr.AutocompleteActions[data.autocompleteSelected] || window.eval(data.autocompleteSelected);

    const options = {
      url: data_url,
      typeMessage: data.autocompleteTypeMessage,
      useAsEnteredMessage: data.autocompleteUseAsEntered,
      formatter,
      select(event, ui) {
        // Trigger autocomplete selected event on the element
        $this.trigger('autocomplete:selected', ui.item);
        return (typeof select_function === 'function' ? select_function(ui.item, event.target) : undefined);
      }
    };

    return $this.data('slzr.autocomplete', new Slzr.Autocomplete($this, options));
  });

  // Attach autocomplete to inputs with [data-autocomplete]
  return $(() => exports.initializeAutocompletes());
});

// Autocomplete selection actions
//
// TODO: organize all these better
namespace('Slzr.AutocompleteActions', function(exports, top) {
  const $ = Slzr.jQuery;

  // Add place to favorites for settings page
  return exports.addPlaceToFavorites = function(item, input) {
    const add_business_friend_url = '/settings/add_favorite_place'; // WP_CHANGE: does this need to be full url
    return $.post(add_business_friend_url, {friend_id: item.id.replace(/business_/, ''), tab: 'places'}, result => $(input).val(''));
  };
});
